import * as React from "react";

export default React.memo(function ToggleWrapper(props) {
  const { children, show = true } = props;

  if (!show) return null;

  return <div>{children}</div>;
});
